import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  dismiss(event) {
    let uuid = event.currentTarget.dataset.modalUuid
    document.getElementById(`modal-${uuid}`).classList.add('hidden')
    document.getElementById('VC-MODAL-BG').classList.add('hidden')
    document.dispatchEvent(new Event('modal-close'))
  }

  // Scrim click only: a click inside the panel bubbles here too and must not close it.
  dismissFromScrim(event) {
    if (event.target !== event.currentTarget) return

    this.dismiss(event)
  }

  show(event) {
    let uuid = event.currentTarget.dataset.modalUuid
    document.getElementById('VC-MODAL-BG').classList.remove('hidden')
    document.getElementById(`modal-${uuid}`).classList.remove('hidden')
  }
}
